var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356 356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255,116h20.5c12.8,0,26.7,18.1,26.5,30.5-2.9,50.3,4,105.2,0,155-1.4,17.4-12.1,29.3-29.5,31.5-61.1-3.2-126.5,4.3-187,0-17.2-1.2-30-11.8-31.5-29.5-4.4-51,3.3-108.3.1-159.9,0-11.5,15.1-27.6,26.4-27.6h145.5v-35.5c0-9.4-9-24.8-16-31-31.3-27.9-79.6-5.6-80,35.5h-30c1.1-17.9,6-35.1,17.5-49C151.6-5.3,218.6-.7,245.2,46.3c3.3,5.9,9.8,21.9,9.8,28.2v41.5ZM271,147H85v155h186v-155Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5,193.6c42.6-.5,40.9,66-4,61.4-36.3-3.7-35-61,4-61.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.5c5653aaea11acb916df5304ee358b31.svg";
export { ForwardRef as ReactComponent };